import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
import { hasOrderedApprovalSteps } from 'ui-product-approvals-common';
export const useHasOrderedApprovalSteps = approvalType => {
  const getIsUngated = useGetIsUngated();
  const isUngated = getIsUngated(GATES.CHANGES_REQUESTED_AND_STAGES) || getIsUngated(GATES.AGENT_APPROVER);
  return isUngated && hasOrderedApprovalSteps({
    approvalType
  });
};